import app from 'app-entrypoint';

if (typeof app === 'function') {
  app();
}



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/primary-early-vote-tracker-2018/config/entry.js
// module id = null
// module chunks = 